import { ref, computed, type Ref, type ComputedRef } from 'vue';
import { stringToDate, parseCivilDate, formatDateToPtBR } from '@/shared/lib';
import { dateToString } from '../lib';
import type { EditHomologationFormData } from './editHomologation.types';

interface HomologationDateState {
  elaborationDate: ComputedRef<Date | null>;
  approvalDate: ComputedRef<Date | null>;
  verificationDate: ComputedRef<Date | null>;
  effectiveDate: ComputedRef<Date | null>;
  elaborationDatePickerOpen: Ref<boolean>;
  approvalDatePickerOpen: Ref<boolean>;
  verificationDatePickerOpen: Ref<boolean>;
  effectiveDatePickerOpen: Ref<boolean>;
  formatDate: (dateString: string | undefined) => string;
}

export function useHomologationDateState(
  formData: EditHomologationFormData
): HomologationDateState {
  const elaborationDatePickerOpen = ref(false);
  const approvalDatePickerOpen = ref(false);
  const verificationDatePickerOpen = ref(false);
  const effectiveDatePickerOpen = ref(false);
  const elaborationDate = computed({
    get: () => stringToDate(formData.elaborationCreatedAt),
    set: (date) => {
      formData.elaborationCreatedAt = dateToString(date);
    },
  });

  const approvalDate = computed({
    get: () => stringToDate(formData.approvalCreatedAt),
    set: (date) => {
      formData.approvalCreatedAt = dateToString(date);
    },
  });

  const verificationDate = computed({
    get: () => stringToDate(formData.verificationCreatedAt),
    set: (date) => {
      formData.verificationCreatedAt = dateToString(date);
    },
  });

  const effectiveDate = computed({
    get: () => parseCivilDate(formData.effectiveDate),
    set: (date) => {
      formData.effectiveDate = dateToString(date);
    },
  });

  const formatDate = (dateString: string | undefined): string => {
    if (!dateString) return 'Selecione uma data';
    const date = stringToDate(dateString);
    return date ? formatDateToPtBR(date) : 'Selecione uma data';
  };

  return {
    elaborationDate,
    approvalDate,
    verificationDate,
    effectiveDate,
    elaborationDatePickerOpen,
    approvalDatePickerOpen,
    verificationDatePickerOpen,
    effectiveDatePickerOpen,
    formatDate,
  };
}
